import type { ReactNode } from "react";
import { App as KonstaApp } from "konsta/react";
import { resolveKonstaTheme, shouldUseKonstaSafeAreas } from "./config";

export type KonstaProviderProps = {
  children: ReactNode;
  className?: string;
};

const DEFAULT_ROOT_CLASSNAME = "min-h-screen";

export const KonstaProvider = ({
  children,
  className = DEFAULT_ROOT_CLASSNAME,
}: KonstaProviderProps) => {
  return (
    <KonstaApp
      theme={resolveKonstaTheme()}
      safeAreas={shouldUseKonstaSafeAreas()}
      className={className}
    >
      {children}
    </KonstaApp>
  );
};
